const en = require('./en.json')
const pt = require('./pt.json')
export {
    en, pt
}